import { render, staticRenderFns } from "./SunFooter.vue?vue&type=template&id=38ab6334&"
import script from "./SunFooter.vue?vue&type=script&lang=js&"
export * from "./SunFooter.vue?vue&type=script&lang=js&"
import style0 from "./SunFooter.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SunFooter.vue"
export default component.exports